import React from 'react';
import { Link } from 'wouter';

import { MicromagItem } from '../../types/micromag';
import PageMeta from '../partials/PageMeta';
import Thumbnail from '../partials/Thumbnail';

import styles from '../../styles/pages/home.module.css';

interface HomePageProps {
    screen?: string | null;
    micromags?: MicromagItem[] | null;
}

function HomePage({ micromags = null }: HomePageProps) {
    const [micromag = null, ...others] = micromags || [];

    return (
        <div className={styles.container}>
            <PageMeta title="Magazines La Poste" />
            <div className={styles.inner}>
                <div className={styles.hero}>
                    <div className={styles.heroInfo}>
                        {micromag !== null ? (
                            <Link
                                className={styles.cellLink}
                                key={micromag?.slug || 'micromag'}
                                href={`/${micromag?.slug || ''}`}
                            >
                                <Thumbnail
                                    className={styles.heroThumbnail}
                                    innerClassName={styles.cell}
                                    micromag={micromag}
                                    titleTag="h1"
                                    withInfo
                                    isPoster
                                />
                            </Link>
                        ) : (
                            <p>À découvrir bientôt...</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
